import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  available: {
    id: 'n2Y5zO',
    defaultMessage: 'Published',
    description: 'Label for the published toggle in the workflow card',
  },
});
